import { RETAGUARDA_API_URL } from 'config'

import { queryTenantsControllerObterPorSubdominio } from 'api/retaguarda'

export function getId() {
  return window.sessionStorage.getItem(process.env.REACT_APP_TENANT_ID_KEY)
}

export function setId(tenantId) {
  return window.sessionStorage.setItem(process.env.REACT_APP_TENANT_ID_KEY, tenantId)
}

export function removeId() {
  return window.sessionStorage.removeItem(process.env.REACT_APP_TENANT_ID_KEY)
}

export function getSubdominioLocal() {
  return window.localStorage.getItem(process.env.REACT_APP_TENANT_SUBDOMINIO_KEY)
}

export function getSubdominioWeb() {
  return process.env.NODE_ENV === 'production' ? window.location.host.split('.')[0] : null
}

export function getSubdominio() {
  return process.env.NODE_ENV === 'production' ? getSubdominioWeb() : getSubdominioLocal()
}

export function setSubdominio(subdominio) {
  return window.localStorage.setItem(process.env.REACT_APP_TENANT_SUBDOMINIO_KEY, subdominio)
}

export function removeSubdominio() {
  return window.localStorage.removeItem(process.env.REACT_APP_TENANT_SUBDOMINIO_KEY)
}

export async function access({ subdominio }) {
  return queryTenantsControllerObterPorSubdominio({
    subdominio,
    base: RETAGUARDA_API_URL
  }).then((data) => {
    setId(data.id)
    setSubdominio(subdominio)

    return { ...data }
  })
}

export function remove() {
  removeId()
  removeSubdominio()

  return Promise.resolve(null)
}

export function bootstrap() {
  const subdominio = getSubdominio()

  if (!subdominio) {
    removeId()
    return Promise.resolve(null)
  }

  return access({ subdominio }).catch(remove)
}
